module.exports = __webpack_public_path__ + "static/media/glycorepair.1142ba08.png";